import { normalizeEmail } from "./normalizeEmail";

export interface AttendeeForDuplicateCheck {
  email?: string;
  isSelected: boolean;
}

/**
 * Returns the (normalized) email addresses that appear more than once among
 * selected attendees with non-empty emails. Order is "first detected
 * duplicate." Empty list means no duplicates.
 *
 * Only checks isSelected attendees — unselected ones aren't being submitted,
 * so a "duplicate" against an unselected row doesn't matter.
 */
export function detectDuplicateEmails(
  attendees: AttendeeForDuplicateCheck[],
): string[] {
  const seen = new Set<string>();
  const duplicates: string[] = [];

  for (const attendee of attendees) {
    if (!attendee.isSelected || !attendee.email) continue;
    const normalized = normalizeEmail(attendee.email);
    if (seen.has(normalized)) {
      duplicates.push(normalized);
    } else {
      seen.add(normalized);
    }
  }

  return duplicates;
}
